(function() {
   angular.module('com.vmware.vsphere.client.vm')
         .constant('vmTypeConstants', {
            VIRTUAL_MACHINE: 'vm',
            TEMPLATE: 'template'
         });
})();
